
import React from "react";
import { Compass, Layers, TreePine } from "lucide-react";

/**
 * Consolidated section replacing:
 * - WhyMeSection (generic USPs)
 * - LeadershipExperienceSection (Katalysator redundancy)
 * - ValueProposition "Katalysator" (duplicate)
 * - ValueProposition "Authentizität statt Zertifikate" (defensive tone)
 * 
 * Design: Understatement, neuroscience-informed (reduced cognitive load, 
 * peak via single strong statement, breathing room via whitespace)
 */
const WhatSetsApartSection = () => {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container max-w-3xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground text-center mb-16">
          Was meine Arbeit prägt
        </h2>

        <div className="space-y-12">
          {/* Katalysator – einmal, prägnant */}
          <div className="flex gap-5">
            <div className="flex-shrink-0 mt-1">
              <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                <Compass className="h-5 w-5" />
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Katalysator, nicht Manager</h3>
              <p className="text-muted-foreground leading-relaxed">
                In meinen Führungsrollen habe ich Teams nicht durch Kontrolle bewegt, sondern durch gezielte Impulse. 
                Dieser Ansatz prägt heute mein Coaching: Ich setze Potenziale frei, statt Lösungen vorzugeben. 
                Veränderung entsteht von innen heraus.
              </p>
            </div>
          </div>

          {/* Analytik + Emotion */}
          <div className="flex gap-5">
            <div className="flex-shrink-0 mt-1">
              <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                <Layers className="h-5 w-5" />
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Analytisch denken, emotional verstehen</h3>
              <p className="text-muted-foreground leading-relaxed">
                Ein naturwissenschaftliches Studium hat mich gelehrt, Systeme zu lesen. Meine eigene Krise hat mich gelehrt, 
                Menschen zu verstehen. Beides verbinde ich in der Arbeit mit meinen Klienten: 
                Klarheit in den Zahlen, Gespür für das, was dahinter liegt.
              </p>
            </div>
          </div>

          {/* Unabhängigkeit statt Abhängigkeit */}
          <div className="flex gap-5">
            <div className="flex-shrink-0 mt-1">
              <div className="h-10 w-10 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                <TreePine className="h-5 w-5" />
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">Wirkung statt Abhängigkeit</h3>
              <p className="text-muted-foreground leading-relaxed">
                Mein Ziel ist es, mich überflüssig zu machen. Wer mit mir arbeitet, entwickelt eigene Handlungsfähigkeit, 
                nicht neue Abhängigkeiten. Die ethischen Standards der International Coaching Federation 
                sind mein Kompass, kontinuierliche Weiterbildung mein Anspruch.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatSetsApartSection;
